import { render, staticRenderFns } from "./ActionManagementCenter.vue?vue&type=template&id=ec152fac&scoped=true&"
import script from "./ActionManagementCenter.vue?vue&type=script&lang=js&"
export * from "./ActionManagementCenter.vue?vue&type=script&lang=js&"
import style0 from "./ActionManagementCenter.vue?vue&type=style&index=0&id=ec152fac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec152fac",
  null
  
)

export default component.exports